import { createSlice } from "@reduxjs/toolkit";

/**
 * Auth Slice — MangoTV
 * Pattern: mirrors glotv authSlice.js with expanded state
 */

const initialState = {
  isAuthenticated: false,
  isLoading: false,
  isValid: false,
  error: null,
  email: "",
  username: "",
  redirectTo: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setIsAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
      if (action.payload) {
        localStorage.setItem("mango_authenticated", "true");
      } else {
        localStorage.removeItem("mango_authenticated");
      }
    },
    setIsValid: (state, action) => {
      state.isValid = action.payload;
    },
    setAuthError: (state, action) => {
      state.error = action.payload;
    },
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setUsername: (state, action) => {
      state.username = action.payload;
    },
    setRedirectTo: (state, action) => {
      state.redirectTo = action.payload;
    },
    resetAuth: () => initialState,
  },
});

export const {
  setIsLoading,
  setIsAuthenticated,
  setIsValid,
  setAuthError,
  setEmail,
  setUsername,
  setRedirectTo,
  resetAuth,
} = authSlice.actions;

export default authSlice.reducer;
